import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  public updateCustomProperty(merchantInfo, element) {
    if (merchantInfo.payStoreSettings) {
      let primaryColor = merchantInfo.payStoreSettings.primaryColor;
      let secondaryColor = merchantInfo.payStoreSettings.secondaryColor;
      let footerColor = merchantInfo.payStoreSettings.footerColor;
      let footerBackgroundColor = merchantInfo.payStoreSettings.footerBackgroundColor;

      if (primaryColor) {
        element.nativeElement.style.setProperty('--primaryColor', primaryColor);
      }
      if (secondaryColor) {
        element.nativeElement.style.setProperty('--secondaryColor', secondaryColor);
      }
      if (footerColor) {
        element.nativeElement.style.setProperty('--footerColor', footerColor);
      }
      if (footerBackgroundColor) {
        element.nativeElement.style.setProperty('--footerBackgroundColor', footerColor);
      }
    }
  }

  processResponse(data) {
    if (typeof data === 'string') {
      try {
        let jsonObject = JSON.parse(data);
        // Now `jsonObject` is the JavaScript object you can work with
        console.log(jsonObject);
        return jsonObject;
        // Perform your operations with jsonObject
      } catch (e) {
        console.error('Error parsing JSON string:', e);
        // Handle error or invalid JSON string
        return data;
      }
    } else {
      // Handle case where data is not a string
      console.log('Received data is not a string:', data);
      return data;
    }
  }

  public isJsonString(data): boolean {
    try {
      JSON.parse(data);
      return true;
    } catch (e) {
      return false;
    }
  }
}
